<template>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card m-5">
        <div class="card-header text-center"><h3>Reset Password</h3></div>
        <div class="card-body">
          <div>
            <inline-message :message="displayMessage" :type="messageType"/>
            <form autocomplete="off" @submit.prevent="submit">
              <div class="mb-3" :class="{ 'hasError': v$.form.password.$errors.length }">
                <label for="password">Password</label>
                <input type="password" id="password" class="form-control" v-model="form.password">
                <div class="error" v-if="v$.form.password.strongPassword.$invalid  && v$.form.password.$dirty">
                  Passwords need to be at least 4 characters long.
                </div>
              </div>
              <div class="mb-3" :class="{ 'hasError': v$.form.passwordConfirm.$errors.length }">
                <label for="password-confirm">Confirm Password</label>
                <input type="password" id="password-confirm" class="form-control"
                       v-model="form.passwordConfirm">
                <div class="error" v-if="v$.form.passwordConfirm.required.$invalid && v$.form.passwordConfirm.$dirty">
                  Password confirmation is required
                </div>
                <div class="error" v-if="v$.form.passwordConfirm.sameAsPassword.$invalid && v$.form.passwordConfirm.$dirty">
                  The passwords do not match.
                </div>
              </div>
              <div class="mb-3 d-flex mb-0">
                <div class="mx-auto">
                  <loading-button type="submit" class="btn btn-primary" :loading="isLoading">
                    <template v-slot:default><i class="fas fa-sign-in-alt"></i></template>
                    <template v-slot:text>&nbsp;Reset Password</template>
                  </loading-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: 'Reset',
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      form: {
        password: null,
        passwordConfirm: null
      },
      isLoading: false,
      displayMessage: '',
      messageType: ''
    }
  },
  validations: {
    form: {
      password: {
        required,
        strongPassword (password) {
          return (
            password !== null &&
            // /[a-z]/.test(password) && // checks for a-z
            // /[0-9]/.test(password) && // checks for 0-9
            // /\W|_/.test(password) && // checks for special char
            password.length >= 4
          )
        }
      },
      passwordConfirm: {
        required,
        sameAsPassword () {
          return this.form.password === this.form.passwordConfirm
        }
      }
    }
  },
  created () {
    this.resetToken = this.$route.query.token
    this.email = decodeURIComponent(this.$route.query.email)
  },
  methods: {
    submit () {
      this.resetMessage()
      this.v$.form.$touch()
      this.invalid = this.v$.form.$invalid
      if (!this.resetToken) {
        this.showMessage('danger', 'No reset token, please check your email for the reset link.')
      } else if (this.invalid === false) {
        this.reset()
      } else {
        this.showMessage('danger', 'The form has errors, please fix them.')
      }
    },
    reset: function () {
      this.isLoading = true
      const data = {
        password: this.form.password,
        confirm_password: this.form.passwordConfirm,
        token: this.resetToken,
        email: this.email
      }
      this.$store.dispatch('reset', data)
        .then(() => {
          this.isLoading = false
          this.$router.push('/')
        })
        .catch(err => {
          console.log(err)
          this.isLoading = false
          this.showMessage('danger', 'There was an error, unable to reset password with those credentials.')
        })
    },
    showMessage (type, msg) {
      this.displayMessage = msg
      this.messageType = type
    },
    resetMessage () {
      this.displayMessage = this.messageType = ''
    }
  }
}
</script>
